import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

const uniqueUserDefinitions = [
  apiDefinitions.uniqueUserScanToPay,
  apiDefinitions.uniqueUserWeb,
  apiDefinitions.uniqueUserApp,
  apiDefinitions.uniqueUserInStore,
  apiDefinitions.uniqueUserOther,
];

const UniqueUserDefinitions = () => {
  const { t } = useTranslation();

  return (
    <APIDefinitions
      definitions={uniqueUserDefinitions}
      type={t(
        'page.loyaltyPerformanceReport.apiDefinitionTitles.uniqueUsers.label',
      )}
    />
  );
};

export default UniqueUserDefinitions;
